export const getValidation = (state) => state.validation.contactUsPage
export const getContactUsFormData = (state) => state.contactUs
